import React from "react";
import HomePage from "src/pages/HomePage";
import PageLayout from "src/pages/PageLayout";

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <PageLayout>
        <div>
          <div className="container py-5">
            <h1 className="text-center text-primary mb-4">Privacy Policy</h1>

            <div className="mb-4">
              <h2 className="text-dark mb-3">Introduction</h2>
              <p className="text-justify">
                Welcome to our Privacy Policy page. Your privacy is critically
                important to us. This policy outlines the types of personal
                information we collect, how we use it, and the steps we take to
                ensure your information remains secure.
              </p>
            </div>

            <div className="mb-4">
              <h2 className="text-dark mb-3">Information We Collect</h2>
              <p className="text-justify">
                We collect personal information you provide directly to us, such
                as when you create an account, fill out a form, or contact us
                for support. The types of personal information we may collect
                include:
              </p>
              <ul className="pl-3">
                <li>Name and email address</li>
                <li>Phone number</li>
                <li>Payment information</li>
                <li>Any other details you choose to provide</li>
              </ul>
            </div>

            <div className="mb-4">
              <h2 className="text-dark mb-3">How We Use Your Information</h2>
              <p className="text-justify">
                The information we collect is used to:
              </p>
              <ul className="pl-3">
                <li>Provide, operate, and maintain our services</li>
                <li>Improve, personalize, and expand our offerings</li>
                <li>Communicate with you, including customer support</li>
                <li>Send updates and promotional materials</li>
              </ul>
            </div>

            <div className="mb-4">
              <h2 className="text-dark mb-3">Data Security</h2>
              <p className="text-justify">
                We are committed to protecting your personal information. We
                implement appropriate technical and organizational measures to
                ensure a level of security appropriate to the risks associated
                with the processing of your personal information.
              </p>
            </div>

            <div className="mb-4">
              <h2 className="text-dark mb-3">Your Rights</h2>
              <p className="text-justify">
                You have the right to access, update, or delete the personal
                information we hold about you. If you wish to exercise these
                rights, please contact us.
              </p>
            </div>

            <div className="mb-4">
              <h2 className="text-dark mb-3">Contact Us</h2>
              <p className="text-justify">
                If you have any questions about this Privacy Policy, you can
                contact us at:
              </p>
              <p className="text-justify">
                Email:{" "}
                <a href="mailto:support@ifrjindex.com">support@ifrjindex.com</a>
              </p>
            </div>
          </div>
        </div>
      </PageLayout>
    </>
  );
};

export default PrivacyPolicy;
